<template>
  <div class="candies">
    <div class="main">
      <img class="bg-img" src="./images/bg.png" alt="" />
      <span class="balance">{{ balance }}</span>
      <button class="btn-info" @click="showInfo()"></button>
      <button class="btn-view" @click="toVipcenter()"></button>
      <img
        class="avatar"
        src="https://resource.3uplay.com/sys-feed/72b8b495-5b20-486d-87db-85c788bc623d4618690156184238774.webp"
        alt=""
      />
      <img class="btn-avatar" src="./images/btn-avatar.png" alt="" />
      <div class="lucky-draw-box">
        <LuckyGrid
          ref="myLucky"
          :width="width"
          :height="height"
          :prizes="prizes"
          :rows="rows"
          :cols="cols"
          :blocks="blocks"
          :buttons="buttons"
          :speed="100"
          :active-style="activeStyle"
          @start="clickDrawButton"
          @end="endLuck"
        />
      </div>
    </div>
    <el-dialog
      :visible.sync="infoDialog"
      width="400px"
      title="糖果獲得規則說明："
      center
      :modal-append-to-body="false"
      class="candies-draw3-dialog"
    >
      <img src="./images/bg-info.png" alt="" @click="infoDialog = false" />
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import Login from '@/components/Login/index';

export default {
  name: 'CandiesDraw',
  data() {
    return {
      width: '700px',
      height: '700px',
      rows: 3,
      cols: 3,
      blocks: [
        {
          padding: '78px',
          // background: '#869cfa',
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/draw-bg.png'),
              width: '100%',
              height: '100%'
            }
          ]
        }
      ],
      prizes: [
        {
          x: 0,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/1.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw3/images/active1.png')
            }
          ]
        },
        {
          x: 1,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/2.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw3/images/active2.png')
            }
          ]
        },
        {
          x: 2,
          y: 0,
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/3.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw3/images/active3.png')
            }
          ]
        },
        {
          x: 2,
          y: 1,
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/4.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw3/images/active4.png')
            }
          ]
        },
        {
          x: 2,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/5.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw3/images/active5.png')
            }
          ]
        },
        {
          x: 1,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/6.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw3/images/active6.png')
            }
          ]
        },
        {
          x: 0,
          y: 2,
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/7.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw3/images/active7.png')
            }
          ]
        },
        {
          x: 0,
          y: 1,
          imgs: [
            {
              src: require('@/activities/candies-draw3/images/8.png'),
              width: '100%',
              height: '100%',
              activeSrc: require('@/activities/candies-draw3/images/active8.png')
            }
          ]
        }
      ],
      activeStyle: {
        background: 'transparent'
      },
      isShowRulesDialog: false,
      drawResult: '', //抽獎結果
      candyCostNumber: 200, //抽一次獎話費糖果數量
      balance: 0, //糖果餘額
      drawLoading: false,
      activityData: {},
      infoDialog: false,
      isUseCandiesDraw: false
    };
  },
  computed: {
    ...mapGetters(['accountInfo', 'userInfo']),
    buttons() {
      return [
        {
          x: 1,
          y: 1,
          imgs: [
            {
              src: this.drawLoading
                ? require('@/activities/candies-draw3/images/active-button.png')
                : require('@/activities/candies-draw3/images/button.png'),
              width: '100%',
              height: '100%'
            }
          ]
        }
      ];
    },
    diamondBalance() {
      return this.accountInfo.diamondBalance;
    }
  },
  methods: {
    // 活動結束提醒
    showFinishedDialog() {
      if (true) {
        this.$confirm({
          content:
            '當前活動已結束，更多福利敬請留意nicee平臺，感謝您的支援呀～',
          title: '提示',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickModal: false
        }).then(() => {
          this.$router.push({ path: '/' });
        });
      }
    },
    // 獲取詳情
    async getDetail() {
      try {
        // this.balance = 500;
        const { data } = await this.$http.get(
          '/activity/getActivityLotteryInfo',
          {
            dictType: 'lotteryConf'
          }
        );
        this.balance = data.crystalBalance || 0;
        this.activityData = data || {};
        this.showFinishedDialog();
      } catch (error) {
        console.log(error);
      }
    },
    // 點擊抽獎按鈕
    async clickDrawButton() {
      await this.checkLogin();
      if (!this.drawLoading) {
        if (this.balance >= this.candyCostNumber) {
          this.isUseCandiesDraw = true;
          this.drawLoading = true;
          this.$confirm({
            content: `將花費${this.candyCostNumber}糖果開始抽獎？`,
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true
          })
            .then(() => {
              this.getDrawInfo();
            })
            .catch(() => {
              this.drawLoading = false;
            });
        } else if (this.diamondBalance >= 500) {
          this.drawLoading = true;
          this.isUseCandiesDraw = false;
          this.$confirm({
            content: `糖果不足，花費500鑽石抽獎？`,
            title: '提示',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true
          })
            .then(() => {
              this.getDrawInfo();
            })
            .catch(() => {
              this.drawLoading = false;
            });
        } else {
          this.$confirm({
            content: '每次抽獎需200糖果或500鑽',
            title: '糖果不足',
            showCancelButton: false,
            confirmButtonText: '確定',
            closeOnClickOverlay: true
          });
        }
      }
    },
    // 獲取抽獎結果
    async getDrawInfo() {
      try {
        const { data } = await this.$http.get('/activity/lottery', {
          dictType: 'lotteryConf',
          count: 1
        });
        if (data) {
          this.drawResult = data;
          if (this.isUseCandiesDraw) {
            this.balance -= this.candyCostNumber;
          } else {
            this.accountInfo.diamondBalance -= 500;
          }
          this.$store.dispatch('app/getUserAccount');
          this.startLuck();
        }
      } catch (error) {
        if (error.msg) {
          this.$message(error.msg);
        }
        console.log(error);
        this.drawLoading = false;
      }
    },

    // 開始抽獎
    startLuck() {
      switch (this.drawResult) {
        case 'P06':
          this.luckIndex = 0; // 謝謝參與
          break;
        case 'P01':
          this.luckIndex = 1; // 88鑽石
          break;
        case 'P02':
          this.luckIndex = 2; // 888鑽石
          break;
        case 'P04':
          this.luckIndex = 3; // 66nicee幣
          break;
        case 'P05':
          this.luckIndex = 4; // 666nicee幣
          break;
        case 'P08':
          this.luckIndex = 5; // 999積分
          break;
        case 'P07':
          this.luckIndex = 6; // 99積分
          break;
        case 'P03':
          this.luckIndex = 7; // 8888鑽
          break;
        default:
          break;
      }
      this.startCallback();
    },
    // 點選抽獎按鈕會觸發start回調
    startCallback() {
      console.log('startCallback');
      // 調用抽獎組件的play方法開始遊戲
      this.$refs.myLucky.play();
      // 調用接口異步抽獎
      setTimeout(() => {
        // 調用stop停止旋轉並傳遞中獎索引
        this.$refs.myLucky.stop(this.luckIndex);
      }, 2000);
    },
    // 抽獎結束
    endLuck() {
      this.drawLoading = false;
      if (this.luckIndex === 0) {
        this.$confirm({
          content: '謝謝參與，祝你好運！',
          title: '很遺憾',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      } else {
        let drawName = '';
        switch (this.drawResult) {
          case 'P08':
            drawName = '999積分';
            break;
          case 'P03':
            drawName = '888鑽石';
            break;
          case 'P01':
            drawName = '88鑽石';
            break;
          case 'P07':
            drawName = '99積分';
            break;
          case 'P05':
            drawName = '666幣';
            break;
          case 'P04':
            drawName = '66幣';
            break;
          case 'P02':
            drawName = '888鑽石';
            break;
          case 'P06':
            drawName = '謝謝惠顧';
            break;
          default:
            break;
        }
        this.$confirm({
          content: `幸運地抽中了：${drawName}`,
          title: '恭喜你！',
          showCancelButton: false,
          confirmButtonText: '確定',
          closeOnClickOverlay: true
        });
      }
    },
    // 检查登录
    checkLogin() {
      return new Promise(resolve => {
        if (!this.userInfo) {
          Login();
          return;
        } else {
          resolve();
        }
      });
    },
    showInfo() {
      this.infoDialog = true;
    },
    toVipcenter() {
      this.$router.push({
        path: `/vip-center`
      });
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.candies {
  width: 100%;
  // height: 100vh;
  background-color: #fffedc;
  overflow: auto;
  text-align: center;
  .main {
    position: relative;
    // background-color: #fef2f5;
    // background-color: #caf5ff;
    display: inline-block;
    width: 980px;
    text-align: left;
    > .bg-img {
      width: 100%;
    }
    .icon {
      position: absolute;
      top: 1422.92px;
      right: 189.81px;
      color: #441bb8;
      z-index: 2;
      width: 327.24px;
      height: auto;
    }
    .balance {
      position: absolute;
      top: 778px;
      right: 267.47px;
      font-size: 40px;
      line-height: 1;
      color: #66142e;
      font-weight: bold;
    }
    .btn-info {
      position: absolute;
      top: 766px;
      right: 198px;
      width: 60px;
      height: 60px;
      // opacity: 0;
    }
    .lucky-draw-box {
      text-align: left;
      display: block;
      width: 700px;
      position: absolute;
      top: 892.92px;
      right: 137px;
    }
    .btn-view {
      position: absolute;
      top: 2875px;
      left: 332px;
      width: 300px;
      height: 80px;
      opacity: 0;
    }
    .avatar {
      position: absolute;
      top: 2234px;
      left: 310px;
      width: 114px;
      height: 114px;
    }
    .btn-avatar {
      position: absolute;
      top: 2339px;
      left: 293px;
      width: 100px;
      height: 35px;
    }
  }
}
</style>
<style lang="scss">
.dialog-center {
  .van-dialog__message,
  .van-dialog__header {
    text-align: center;
  }
}
.candies-draw3-dialog {
  .el-dialog {
    background-color: transparent;
  }
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    display: flex;
    flex-direction: column;
  }
}
</style>
